/// <summary>
/// This object provides js functions for device application tags <br/>
/// <br/>
/// Author: AFU<br />
/// Date: 1.4.2025<br />
/// Copyright ©: EUDT GmbH 2025 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 1.4.2025                                             *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>


jQuery.widget("bluaul.ApplicationTags", jQuery.common.vcBaseV4, {
    myStatus: {id:-1},
    _create: function () {
   
        this._createVisual(385);
        this._super();
    },

    _initHTML: function () {
        var me = this;
        try {
           
            me._setRoot(".dm-application-tags");
          
            me._buildHtml();
            me._setHeightsAndWidths();
        } catch (e) { me._writeErr(e); return false;}
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {
            me._initStructure();
          
            me._fetch();
        } catch (e) { me._writeErr(e);return false; }
        return true;
    },

    _buildHtml: function () {
        /// <summary>
        /// This function builds the html structure only
        /// </summary>
        var me = this;
        try {

         
            me.myHtml = {
                tree: {}, menu: {}, form: {} };
            //top menu for save button
            let obj = me.myHtml.menu;
            obj.wrapper = me._setObj("div-menu", "vc-grid-margin-bottom").css("width", "100%").css("height", "30px");
            obj.btnNew = me._setObj("div-btn-new", "vc-grid-1col float-box").css("float", "right").html(me.specific.resources.new);
            obj.wrapper.append(obj.btnNew);
            me.myRoot.append(me.myHtml.menu.wrapper);

            obj = me.myHtml.tree;
            obj.wrapper = me._setObj("", "ui-jqgrid-tree vc-grid-margin-bottom").css("width", "100%").css("height", "100%");

            obj.tree = $("<table>").attr("id", "tbl-tree");
            obj.wrapper.append(obj.tree);
            me.myRoot.append(me.myHtml.tree.wrapper);

            obj = me.myHtml.form;
            obj.wrapper = me._setObj("div-form", "").css("width", "100%").css("height", "100%").hide();

            me.myRoot.append(me.myHtml.form.wrapper);


        } catch (e) {me._writeErr(e);return false;}
        return true;
    },

    _initStructure: function () {
        /// <summary>
        /// This function inits various events and handlers
        /// </summary>
        var me = this;
        try {


            //add event handler for closing the ticket entry
            _VCMQ.addConsumer('local');
            _VCMQ.consume($("<div>"), 'local', function (e) { me._doEvents(e); });


            //new button click handler
            me.myHtml.menu.btnNew.off("click").on("click", function () {
                me._openEditForm(-1);
            }).button();

        } catch (e) { me._writeErr(e); }
    },

    _doEvents: function (e) {
        /// <summary>
        /// This function handles the data changed event from the form
        /// </summary>
        var me = this;
        try {
            switch (e.msg) {
                case "DMATAGID_REFRESH":

                    if (e.values.toString().length > 0)  me.myStatus.id = e.values;
                    me._fetch(); break;
                default: break;
            }
        } catch (e) { me._writeErr(e); }
    },

    _loadTree: function () {
        /// <summary>
        /// This function inits various events and handlers
        /// </summary>
        var me = this;
        try {
            me.myHtml.menu.wrapper.show();
            me.myHtml.tree.wrapper.show();
            me.myHtml.form.wrapper.hide();



            var colModel = [
                { "name": "Id", "index": "id", "key": true, "hidden": true },
                { "name": "Name", "index": "name", "label": "Name", "width": 300, classes: "multiline-cell" },
                { "name": "ParentId", "hidden": true }
            ];

            $.each(me.specific.subLanguages, function () {
                if (this.ShortCut != "DE")  colModel.push({ "name": this.ShortCut, "label": this.ShortCut, "width": 150 });
            });


            //colModel.push({ "name": "Edit", "label": "Edit", "width": 30 });
            colModel.push({ "name": "Del", "label": "Del", "width": 30 });

            //TODO:set height, width and names
            me.myHtml.tree.tree.jqGrid({
                "colModel":colModel,
                "width": "1000", "height": parseInt(me.myHtml.tree.wrapper.height()), "hoverrows": true,
                "viewrecords": false, "gridview": false, "sortorder": "asc", "datatype": "json", "pager": "",
                 "loadonce": false, "rowNum": 100, "scrollrows": true,
                // enable tree grid
                "treeGrid": true, "ExpandColumn": "Name", "treedatatype": "json","treeGridModel": "adjacency",
                // configuration of the data comming from server
                "treeReader": {

                    "parent_id_field": "ParentId",
                    "level_field": "Level",
                    "leaf_field": "IsLeaf",
                    "expanded_field": "expanded",
                    "loaded": "loaded"
                
                },
                onCellSelect: function (rowid, iCol, cellcontent, e) {
                    if (iCol == 1) {
                        //edit current 
                        me._openEditForm(rowid);
                    }

                }
            });



            $.each(me.myData, function () {
                var entry = this;
                entry.expanded = true;
                //this.Edit = "<i class='fa fa-pen icon-color-warning'></i>";
                entry.Del = entry.IsLeaf ? "<i class='fa fa-times fa-2x icon-color-error'></i>" : "";
                $.each(me.specific.subLanguages, function () {
                  
                    if (this.ShortCut != "DE") {
                        entry[this.ShortCut] = this.Name;
                    }

                });
            });
            console.info(me.myData);


            //add data
            me.myHtml.tree.tree[0].addJSONData({ rows: me.myData });
            ////hide header
            //me.myHtml.tree.wrapper.find(".ui-jqgrid-hdiv").hide();
            //collapse all nodes
            //me.myHtml.tree.tree.jqGrid('collapseAll');


            if (me.myStatus.id > -1) {
                console.info("select node: " + me.myStatus.id);
                me.myHtml.tree.tree.jqGrid("setSelection", me.myStatus.id, true);

            }

            //select the first one
          

          

        } catch (e) { me._writeErr(e); }
    },


    _openEditForm: function (id) {
        /// <summary>
        /// This function
        /// </summary>
        var me = this;
        try {
            me.myStatus.id = id;

            me.myHtml.menu.wrapper.hide();
            me.myHtml.tree.wrapper.hide();
            me.myHtml.form.wrapper.show();

            me.vcV.addVisualBaseByName('div-f', "VISUAL_FORM_DM_APPLICATION_TAGS", 'orm', getCurrentTimestamp(), parseInt(me.myHtml.form.wrapper.height()), parseInt(me.myHtml.form.wrapper.width()), "", "{Dmatagid:" + me.myStatus.id + "}", 1);
        } catch (e) { me._writeErr(e); return false; } return true;
    },


    _fetch: function () {
        /// <summary>
        /// This function fetches the data based on the current settings
        /// </summary>
        var me = this;
        try {
            //me._setLoadingIcon(me.myHtml.list.entries);
            me.getData({ TypeId: 1 }, function (result) {
                
                //check response content
                if (result == null) { me.showMessage(me.resources.err_loadData, true); return true; }
                me.myData = result;
                me._generateList();
               
            });
        } catch (e) { me._writeErr(e); return false; }return true;
    },

    _generateList: function () {
        /// <summary>
        /// This function generates the table and fills the list with data
        /// </summary>
        var me = this;
        try {
           
            if (me.myData.length == 0) {
                //me.myHtml.list.entries.html($("<br>")).append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }


            me._loadTree();

            return true;

        } catch (e) {
            me._writeErr(e);
            return false;
        }
    },


    _setHeightsAndWidths: function () {
        /// <summary>
        /// This function calculates and sets the height of elements relatively to the general content height
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }
          
            var h = me._getVisualHeight() - me.myHtml.menu.wrapper.height();
            me.myHtml.tree.wrapper.css("height", h);

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    specificInfoHandling: function (bError) {
        /// <summary>
        /// This function handles error states - it hides specific objects on error message
        /// </summary>
        var me = this;
        try {
            if (bError) {
                me.myHtml.tree.wrapper.hide();
                //me.myHtml.list.wrapper.hide();
            }
           
        } catch (e) { me._writeErr(e); return false;}
        return true;
    }
});